import intl from "react-intl-universal";

export const createGenderOptions = () => [
  {
    label: intl.get("GENDER_SELECT_MALE"),
    value: 1
  },
  {
    label: intl.get("GENDER_SELECT_FEMALE"),
    value: 0
  }
];
